import React, { useEffect, useState } from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { connect } from "react-redux";
import { fetchApi } from "../../api";
import { STYLES } from "../../assets/styles";
import Container from "../../components/Container";
import Header from "../../components/Header";
import ListItems from "../../components/ListItems";

function Notifications({ navigation }) {
  const [refreshing, setRefreshing] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const onRefresh = async () => {
    setRefreshing(true);
    await fetchNotifications();
    setRefreshing(false);
  };

  const fetchNotifications = () => {
    return fetchApi({ path: "/notifs" }).then((res) => {
      if (res.results) {
        setNotifications(res.results);
      }
    });
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const onNotificationPress = ({ id, index, is_seen }) => {
    if (!is_seen) {
      fetchApi({ path: `/notifs/${id}`, method: "PUT" }).then((res) => {
        if (!res.error) {
          notifications[index] = res;
          setNotifications(notifications);
        }
      });
    }
  };

  const Item = ({
    index,
    data: { title, text, image_urls = [], is_seen, _id },
  }) => (
    <TouchableOpacity
      onPress={() => onNotificationPress({ id: _id, index, is_seen })}
    >
      <View
        style={[
          STYLES.shadow,
          {
            borderRadius: 5,
            padding: 10,
            marginVertical: 5,
            flexDirection: "row",
            display: "flex",
            backgroundColor: is_seen ? "#ffffff" : STYLES.colors.purpel + "10",
          },
        ]}
      >
        <View style={{ flex: 1 }}>
          <Text style={{ fontWeight: "bold" }}>{title}</Text>
          <Text style={{ paddingLeft: 5, color: STYLES.colors.lightFontColor }}>
            {text}
          </Text>
        </View>
        <View
          style={{
            height: image_urls.length ? 80 : 0,
            width: image_urls.length ? 80 + image_urls.length * 10 : 0,
            flexDirection: "row",
          }}
        >
          {image_urls.map((imageUrl, index) => (
            <Image
              key={index + "im"}
              source={{ uri: imageUrl }}
              style={{
                width: 80,
                height: 80,
                position: "absolute",
                left: index * 10,
              }}
            />
          ))}
        </View>
      </View>
    </TouchableOpacity>
  );

  return (
    <Container secure>
      <Header backButton title="Notifications" navigation={navigation} />
      <ListItems
        empty={{
          iconType: "FontAwesome",
          iconName: "bell",
          text: "No Notification for you",
        }}
        data={notifications}
        renderItem={(item, index) => <Item key={index + "nf"} data={item} />}
        refreshing={refreshing}
        refresh={true}
        onRefresh={onRefresh}
      />
    </Container>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
